const basePath = '/assets/pixi-assets/bb-cross/'

export const path = {
  imagePath: basePath + 'images/',
  spinePath: basePath + 'spine/',
  fontsPath: basePath + 'fonts/'
}

export const settings = {
  originalWidth: 1920,
  originalHeight: 786,
  currentWidth: 1920,
  currentHeight: 870,
  windowWidth: 1920,
  windowHeight: 870,
  backgroundColor: '#1F1F2B',
  backgroundAlpha: 1,
  devicePixelRatio: 1.6,
  div: () => document.getElementById('pixi-game'),
  resizeThrottleDelay: 0,
  music: true,
  sound: true,
  vibration: true
}
